import React from 'react'
import { AuditRecord } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { StandardOpenModalButton } from 'src/components/ModalForms/ModalButtons'
import { useGetRoleAccessConfig } from 'src/app/AppAuth/AppAuth.hooks'
import { useUser } from 'src/components/async/Users/useUser'
import { P } from 'src/components/Reusable/Text/Text.styles'
import { ModalFormId } from '../../../components/ModalForms'
import { Grid } from '../../../components/Reusable/Grid'
import { AuditIcon } from '../../../components/Icons/Basic/AuditIcon'
import {
  StandardButtonSize,
  StandardButtonVariant,
} from '../../../components/Reusable/Buttons'
import { AuditIndexItem } from './AuditIndexItem'
import { AuditIndexGridHeader } from './AuditIndexGridHeader'
import { GetStartedBox, GetStartedText } from './AuditIndexGrid.styles'

type AuditIndexGridProps = {
  isEmpty: boolean
  audits: AuditRecord[]
}

export const AuditIndexGrid = ({
  isEmpty,
  audits,
}: AuditIndexGridProps): JSX.Element => {
  const {
    routeConfig: { restrictToAuditView },
  } = useGetRoleAccessConfig()
  const { data: user } = useUser()

  if (!user) return <></>

  if (isEmpty) {
    return <AuditIndexEmptyState restrictToAuditView={restrictToAuditView} />
  }

  return (
    <Grid
      gridTemplateColumns={'min-content 1fr 1fr 2fr min-content min-content'}
      gridAutoRows="max-content"
      height={'100%'}
      width={'100%'}
    >
      <AuditIndexGridHeader />
      {audits.map((audit) => (
        <AuditIndexItem key={audit.getId()} audit={audit} />
      ))}
    </Grid>
  )
}
export const AuditIndexEmptyState = ({
  restrictToAuditView,
}: {
  restrictToAuditView: boolean
}): JSX.Element => {
  return restrictToAuditView ? (
    <GetStartedBox>
      <GetStartedText>
        <P>
          You do not have access to any audits. Please contact your account
          administrator to request access.
        </P>
      </GetStartedText>
    </GetStartedBox>
  ) : (
    <GetStartedBox>
      <GetStartedText>
        <AuditIcon />
        <p>Get started on your first audit</p>
      </GetStartedText>
      <StandardOpenModalButton
        variant={StandardButtonVariant.PRIMARY}
        size={StandardButtonSize.SMALL}
        modalId={ModalFormId.ADD_AUDIT}
        text="Setup an Audit"
      />
    </GetStartedBox>
  )
}
